import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { FaHeart } from 'react-icons/fa';

const API_URL = process.env.REACT_APP_API_URL || 'https://edulove-backend.onrender.com/api';

function LoginPage({ setIsAuthenticated, setUser }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('[LoginPage] Attempting login with email:', email);
      console.log('[LoginPage] API URL:', API_URL);
      
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password
      });

      console.log('[LoginPage] Login successful, got token:', response.data.token.substring(0, 20) + '...');
      
      localStorage.setItem('token', response.data.token);
      setUser(response.data.user);
      setIsAuthenticated(true);
      navigate('/discover');
    } catch (err) {
      console.error('[LoginPage] Login error:', err.response?.status, err.response?.data || err.message);
      const errorMsg = err.response?.data?.error || err.message || 'Login failed';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen gradient-header flex items-center justify-center p-4">
      <div className="w-full max-w-md card">
        <div className="text-center mb-6">
          <button onClick={() => navigate('/')} className="flex items-center justify-center space-x-2 mx-auto mb-2 hover:scale-105 transition">
            <FaHeart className="text-4xl text-pink-500" />
          </button>
          <h1 className="text-3xl font-bold text-gray-800">EduLove</h1>
          <p className="text-gray-600">Connect with students</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input
              type="password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
              {error}
            </div>
          )}

          <div className="flex items-center justify-between">
            <button
              type="submit"
              disabled={loading}
              className="w-1/2 btn-primary font-medium disabled:opacity-50 mr-2"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
            <Link to="/reset" className="text-sm text-pink-500 hover:text-pink-600">Forgot password?</Link>
          </div>
        </form>

        <p className="text-center mt-4 text-gray-600">
          Don't have an account?{' '}
          <Link to="/register" className="text-pink-500 hover:text-pink-600 font-medium">
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
